import { Controller, useFormContext } from 'react-hook-form'

type Props = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  name: string
}

export default function RHFTextArea({ name, ...other }: Props) {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <textarea
          {...field}
          value={field.value ?? ''}
          onChange={(event) => field.onChange(event.target.value)}
          {...other}
        />
      )}
    />
  )
}
